import BaseButton from './BaseButton';
import Button from './Button';
import LinkButton from './LinkButton';
import { type ButtonVariantProps, buttonVariants } from './styles';

export type ButtonTheme = ButtonVariantProps['theme'];

export type { ButtonProps } from './Button';
export type { LinkButtonProps } from './LinkButton';
export { BaseButton, Button, buttonVariants, LinkButton };
export default Button;
